import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6 group">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/629dc85fc734a1771685601969667fb4.png" 
                  alt="HP Inc Consulting Services Logo" 
                  className="w-14 h-14 object-contain transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white" style={{ fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '-0.02em' }}>
                  HP Inc Consulting Services
                </h3>
                <p className="text-xs font-semibold text-orange-400 tracking-wide">
                  Safety • Environmental • Coatings
                </p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Leading safety consulting company specializing in OSHA compliance, industrial hygiene, and environmental solutions.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-twitter-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-600 transition-colors">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-instagram-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Core Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-orange-400">Core Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/safety-staffing" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                  <i className="ri-team-fill text-orange-500 mr-2"></i>
                  Safety Staffing
                </Link>
              </li>
              <li>
                <Link to="/industrial-hygiene" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                  <i className="ri-microscope-fill text-blue-500 mr-2"></i>
                  Industrial Hygiene
                </Link>
              </li>
              <li>
                <Link to="/osha-consulting" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                  <i className="ri-shield-check-fill text-green-500 mr-2"></i>
                  OSHA Consulting
                </Link>
              </li>
              <li>
                <Link to="/osha-training" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                  <i className="ri-graduation-cap-fill text-purple-500 mr-2"></i>
                  OSHA Training
                </Link>
              </li>
              <li>
                <Link to="/coating-inspection" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                  <i className="ri-brush-fill text-yellow-500 mr-2"></i>
                  Coating Inspection Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-orange-400">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mission-vision" className="text-gray-300 hover:text-orange-400 transition-colors">
                  Mission & Vision
                </Link>
              </li>
              <li>
                <Link to="/core-values" className="text-gray-300 hover:text-orange-400 transition-colors">
                  Core Values
                </Link>
              </li>
              <li>
                <Link to="/meet-team" className="text-gray-300 hover:text-orange-400 transition-colors">
                  Meet Our Team
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-300 hover:text-orange-400 transition-colors">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-300 hover:text-orange-400 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-orange-400 transition-colors">
                  News & Updates
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-orange-400">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-orange-500 mt-1"></i>
                <div>
                  <p className="text-gray-300">123 Safety Boulevard</p>
                  <p className="text-gray-300">Industrial District, NY 10001</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-fill text-orange-500"></i>
                <a href="tel:+1234567890" className="text-gray-300 hover:text-orange-400 transition-colors">
                  (123) 456-7890
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-fill text-orange-500"></i>
                <a href="mailto:info@hpinc-safety.com" className="text-gray-300 hover:text-orange-400 transition-colors">
                  info@hpinc-safety.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-fill text-orange-500"></i>
                <div>
                  <p className="text-gray-300">24/7 Emergency Response</p>
                  <p className="text-gray-400 text-sm">Mon-Fri: 8AM-6PM EST</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 HP Inc. Consultant Services. All rights reserved. | Privacy Policy | Terms of Service
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-400 text-sm">Powered by</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300 transition-colors text-sm font-medium"
              >
                Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
